import { render, staticRenderFns } from "./ProjeDetay.vue?vue&type=template&id=87001e8a&scoped=true&"
import script from "./ProjeDetay.vue?vue&type=script&lang=js&"
export * from "./ProjeDetay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87001e8a",
  null
  
)

export default component.exports